(function (i, t, e, r, a) {
  if (t.getElementById(r)) { return; }
  i.IterateObjectName = a; var z = function () { z.c(arguments); }; z.q = [];
  z.c = function (args) { z.q.push(args); }; i[a] = z;
  function l() { let js; const fjs = t.getElementsByTagName(e)[0]; js = t.createElement(e); js.id = r; js.async = 1; js.src = 'https://platform.iteratehq.com/loader.js'; fjs.parentNode.insertBefore(js, fjs); }
  if (t.readyState === 'complete') { l(); } else if (i.attachEvent) { i.attachEvent('onload', l); } else { i.addEventListener('load', l, false); }
}(window, document, 'script', 'iterate-js', 'Iterate'));
